import { render, staticRenderFns } from "./generalClassAttendanceDialog.vue?vue&type=template&id=61c20ffd&scoped=true"
import script from "./generalClassAttendanceDialog.vue?vue&type=script&lang=js"
export * from "./generalClassAttendanceDialog.vue?vue&type=script&lang=js"
import style0 from "./generalClassAttendanceDialog.vue?vue&type=style&index=0&id=61c20ffd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c20ffd",
  null
  
)

export default component.exports